import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';

// Botão flutuante de suporte via WhatsApp. Aparece em todo o dashboard
// autenticado pro casal pedir ajuda direta. O número fica no .env (Vite)
// pra facilitar troca; cai num fallback se não definido.
const SUPPORT_WHATSAPP = import.meta.env.VITE_SUPPORT_WHATSAPP || '5511977642485';
const DEFAULT_MESSAGE = 'Olá! Preciso de ajuda com o Mimo do Casal.';

export function WhatsAppFab({ presetMessage }) {
  const [hovered, setHovered] = useState(false);
  const msg = encodeURIComponent(presetMessage || DEFAULT_MESSAGE);
  const href = `https://wa.me/${SUPPORT_WHATSAPP}?text=${msg}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      onFocus={() => setHovered(true)}
      onBlur={() => setHovered(false)}
      className="fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-40 flex items-center gap-2 pl-3 pr-3 sm:pr-4 py-3 rounded-full text-white shadow-2xl shadow-emerald-600/30 hover:shadow-emerald-600/50 hover:scale-105 active:scale-95 transition-all"
      style={{ background: 'linear-gradient(135deg, #25D366, #128C7E)' }}
      aria-label="Falar com suporte no WhatsApp"
      title="Falar com suporte no WhatsApp"
    >
      <MessageCircle size={20} fill="white" strokeWidth={1.5} />
      <AnimatePresence initial={false}>
        {hovered && (
          <motion.span
            key="label"
            initial={{ opacity: 0, width: 0 }}
            animate={{ opacity: 1, width: 'auto' }}
            exit={{ opacity: 0, width: 0 }}
            transition={{ duration: 0.2 }}
            className="text-sm font-semibold whitespace-nowrap overflow-hidden"
          >
            Falar no WhatsApp
          </motion.span>
        )}
      </AnimatePresence>
    </a>
  );
}
